'use client';

import { atgAdminCompanySwitchDirtyCountAtom } from '@/atoms/admin/atgAdminCompanySwitchDirtyCountAtom';
import { useAtomValue, useSetAtom } from 'jotai';
import { useEffect } from 'react';
import { useHasPermission } from '@/hooks/useHasPermission/useHasPermission';

/**
 * When the user is ATG admin and `isBlockingDirty` is true, increments a global refcount so
 * CompanySwitcher can block context switches. Cleanup decrements. Non-admins are no-ops.
 */
export const useRegisterAtgAdminCompanySwitchDirty = (isBlockingDirty: boolean) => {
    const { isAtgAdmin } = useHasPermission();
    const setDirtyCount = useSetAtom(atgAdminCompanySwitchDirtyCountAtom);

    useEffect(() => {
        if (!isAtgAdmin || !isBlockingDirty) {
            return;
        }
        setDirtyCount((count) => count + 1);
        return () => {
            setDirtyCount((count) => count - 1);
        };
    }, [isAtgAdmin, isBlockingDirty, setDirtyCount]);
};

export const useHasAtgAdminCompanySwitchBlockingDirty = () => {
    const count = useAtomValue(atgAdminCompanySwitchDirtyCountAtom);
    return count > 0;
};
